import mixin from "../mixins";
import ServiceCancellationTerms from "@/components/custom/service-cancellation-terms.vue";

export default {
  components: { ServiceCancellationTerms },
  props: {
    service: Object,
    index: Number,
    fromOrder: Boolean,
    isRemove: Boolean
  },
  computed: {},
  mixins: [mixin],
  data: function () {
    return {};
  },
  methods: {}
};
